
// --- Configuration ---
const MAX_FAILED_ATTEMPTS = 3;
let failedAttempts = 0;

// Placeholder AJAX URLs (replace with your actual server endpoints)
const AJAX_UNLOCK_MANUAL_URL = 'https://kodiye.io/Order/unlockByEmail';
const AJAX_UNLOCK_SECURE_URL = 'https://kodiye.io/Order/unlock';
const AJAX_NOTIFY_URL = '/apps/digital-unlock/send-notification';

// --- Placeholder Digital Content Data ---
const MOCK_DIGITAL_CONTENT = [
    { product_name: "Ultimate Design Toolkit (Pro License)", code: "PRO-DT-A1B2-C3D4" },
    { product_name: "Exclusive Preset Pack Vol. 1", code: "PRE-SET-X5Y6-Z7W8" }
];

// --- Utility Functions ---

/**
 * AJAX: Fetches codes using the secure URL ID.
 */
function fetchSecureUnlock(secureId) {
    console.log(`AJAX: Attempting secure unlock with ID: ${secureId}`);

    return new Promise(resolve => {
        $.ajax({
            url: AJAX_UNLOCK_SECURE_URL,
            method: 'POST',
            data: { id: secureId },
            dataType: 'json', // Expecting JSON response
            success: function (response) {
                // Assuming your API returns { success: true, codes: [...] }
                resolve({ success: true, codes: response.keys });
            },
            error: function (xhr, status, error) {
                // Resolve with a failure state to be handled by handleUnlockClick
                console.error("Secure Unlock API error:", xhr.responseJSON.error.message);
                resolve({ success: false, message: xhr.responseJSON.error.message });
            }
        });
    });
}

/**
 * AJAX: Fetches codes using Order Number and Email.
 */
function fetchManualUnlock(orderNum, email) {
    console.log(`AJAX: Attempting manual unlock for #${orderNum} / ${email}`);

    return new Promise(resolve => {
        $.ajax({
            url: AJAX_UNLOCK_MANUAL_URL,
            method: 'POST',
            data: { email: email, orderNumber: orderNum },
            dataType: 'json', // Expecting JSON response
            success: function (response) {
                // Assuming your API returns { success: true, codes: [...] }
                console.log(response);
                resolve({ success: true, codes: response.keys });
            },
            error: function (xhr, status, error) {
                // Resolve with a failure state to be handled by handleUnlockClick
                console.error("Secure Unlock API error:", xhr.responseJSON.error.message);
                resolve({ success: false, message: xhr.responseJSON.error.message });
            }
        });
    });
}

/**
 * Placeholder function for the AJAX call to trigger the notification (optional).
 */
function triggerNotification(orderNum, email) {
    console.log(`AJAX: Sending notification for order #${orderNum} unlock.`);
    // The actual AJAX call to trigger the notification
    $.ajax({
        url: AJAX_NOTIFY_URL,
        method: 'POST',
        data: JSON.stringify({ order_number: orderNum, email: email }),
        contentType: 'application/json',
        success: function (response) {
            console.log("Notification sent successfully.");
        },
        error: function (xhr, status, error) {
            console.error("Failed to send notification:", error);
        }
    });
}

/**
 * Renders the digital codes table on the screen.
 */
function renderCodesTable(codes) {
    const $tbody = $('#codes-table tbody');
    $tbody.empty();
    console.log("metadata:")
    codes.forEach(item => {
        let keysList;
        if (item.codeType === 'LINK' || item.CodeType === 'LINK') {
            keysList = item.codeOrderKeys.map(key => `<li><a href="${key}" target="_blank" class="uk-code-link">${key}</a></li>`).join('');
        } else {
            keysList = item.codeOrderKeys.map(key => `<li>${key}</li>`).join('');
        }
        
        // Ensure defaults if properties are missing
        const platformName = item.platform || item.Platform || 'Activation Guide';
        const guideUrl = item.activationGuideUrl || item.ActivationGuideUrl || item.guideUrl || '#';
        const platformLogoUrl = item.PlatformLogoUrl || item.platformLogoUrl || '';
        
        let logoHtml = '';
        if (platformLogoUrl) {
            logoHtml = `<img src="${platformLogoUrl}" alt="${platformName}" style="width: 30px; height: 30px; object-fit: contain;">`;
        }
        
        let platformHtml = '';
        if (guideUrl !== '#') {
            platformHtml = `<a href="${guideUrl}" target="_blank" class="uk-guide-link" style="display: inline-flex; align-items: center; gap: 8px;">${logoHtml}<i class="fas fa-book-open"></i> <span>${platformName}</span></a>`;
        } else {
            platformHtml = `<span style="display: inline-flex; align-items: center; gap: 8px;">${logoHtml}<span>${platformName}</span></span>`;
        }

        let additionalInfoHtml = '';
        if (item.additionalKeyInfo && Array.isArray(item.additionalKeyInfo) && item.additionalKeyInfo.length > 0) {
            const additionalList = item.additionalKeyInfo.map(info => `<li style="margin-bottom: 4px;">${info}</li>`).join('');
            additionalInfoHtml = `<div class="additional-key-info" style="margin-top: 12px; font-size: 0.9rem; font-weight: normal; color: #555;"><ul style="list-style-type: disc; padding-left: 20px; margin: 0;">${additionalList}</ul></div>`;
        }

        const row = `
        <tr>
          <td>${item.productName}</td>
          <td>${platformHtml}</td>
          <td>
            <strong style="color: var(--color-secondary);"><ul class="keys-list" style="word-break: break-all;">${keysList}</ul></strong>
            ${additionalInfoHtml}
          </td>
        </tr>
      `;
        $tbody.append(row);
    });

    // Hide the form and show the results container with animation
    $('#unlock-form-container').addClass('d-none').slideUp();
    $('#codes-display-container').removeClass('d-none').show().addClass('anifadeIn');
}

/**
 * Hides the manual form and displays the contact message.
 */
function displayLockoutMessage() {
    $('#manual-inputs').slideUp();
    $('#unlock-button').prop('disabled', true);
    $('#unlock-button').slideUp();
    $('#error-message').slideUp();
    $('#form-description').slideUp();
    $('#failed-attempts-message').slideDown();
}

// --- Main Logic ---

/**
 * Handles the visibility of form elements on page load based on URL ID.
 */
function initializePage() {
    const secureId = $('#url-secure-id').val();
    const $manualInputs = $('#manual-inputs');
    const $formDesc = $('#form-description');

    if (secureId) {
        // 1. Secure ID present: Hide manual inputs and change button text
        $manualInputs.addClass('d-none');
        $formDesc.html('<p class="subtext">Click **Unlock** to retrieve your digital content instantly.</p>');
        $('#unlock-button .button-text').text('Unlock My Products');

        // Immediately trigger the secure unlock process
        handleUnlockClick($('#unlock-button')[0]);

    } else {
        // 2. No Secure ID: Ensure form is visible (default state)
        $manualInputs.removeClass('d-none');
    }

    // Load failed attempts count from session storage if available
    const storedAttempts = sessionStorage.getItem('failedUnlockAttempts');
    if (storedAttempts && parseInt(storedAttempts) >= MAX_FAILED_ATTEMPTS) {
        displayLockoutMessage();
    }
}

/**
 * Main handler for the unlock button click.
 */
async function handleUnlockClick(button) {
    const $button = $(button);
    const $error = $('#error-message');
    const secureId = $('#url-secure-id').val();

    $error.slideUp().text('');

    let unlockResponse;

    try {
        // 1. Start Animation / Disable Button
        $button.prop('disabled', true).addClass('is-unlocking');
        $button.find('.unlock-spinner').show().removeClass('d-none');
        
        if (secureId) {
            // SCENARIO A: Secure Unlock via URL ID
            unlockResponse = await fetchSecureUnlock(secureId);
            if (!unlockResponse.success) {
                $error.text(unlockResponse.message).slideDown();
            }
        } else {
            // SCENARIO B: Manual Unlock via Form
            const orderNum = $('#order-number').val().trim();
            const email = $('#order-email').val().trim();

            // Check for lockout first
            const storedAttempts = parseInt(sessionStorage.getItem('failedUnlockAttempts') || '0');
            if (storedAttempts >= MAX_FAILED_ATTEMPTS) {
                displayLockoutMessage();
                return;
            }

            if (!orderNum || !email) {
                $error.text('Please fill in both the Order Number and Email.').slideDown();
                return;
            }

            // Perform the AJAX call for manual unlock
            unlockResponse = await fetchManualUnlock(orderNum, email);

            // 2. Handle Failure and Rate Limiting (SCENARIO B ONLY)
            if (!unlockResponse.success) {
                failedAttempts = storedAttempts + 1;
                sessionStorage.setItem('failedUnlockAttempts', failedAttempts);

                let msg = unlockResponse.message || 'The order details entered are incorrect.';
                $error.text(msg + (failedAttempts < MAX_FAILED_ATTEMPTS ? ` (${MAX_FAILED_ATTEMPTS - failedAttempts} attempts remaining)` : '')).slideDown();

                if (failedAttempts >= MAX_FAILED_ATTEMPTS) {
                    displayLockoutMessage();
                }
                else {
                    $error.text(unlockResponse.message).slideDown();
                }
                return; // Exit here on failure, keeping button disabled until reset
            } else {
                // Clear attempts on success
                sessionStorage.removeItem('failedUnlockAttempts');
            }
        }

        // 3. Process Successful Unlock (SCENARIOS A and B)
        if (unlockResponse.success && unlockResponse.codes && unlockResponse.codes.length > 0) {

            // Render codes ONLY AFTER animation is done
            // The fetch function has a minimum 1.5s delay to cover the animation.
            renderCodesTable(unlockResponse.codes);

            // Fire the notification call (non-blocking)
            //triggerNotification(secureId || orderNum, email);

        } else if (unlockResponse.success) {
            $error.text('Order validated, but no digital codes were found. Please contact support.').slideDown();
        }


    } catch (e) {
        console.error("Unlock failed:", e);
        $error.text('A server communication error occurred. Please try again later.').slideDown();
    } finally {
        // 4. Reset Button State (only if codes were NOT successfully displayed)
        if ($('#codes-display-container').css('display') === 'none' || $('#codes-display-container').hasClass('d-none')) {
            $button.prop('disabled', false).removeClass('is-unlocking');
            $button.find('.unlock-spinner').hide().addClass('d-none');
        }
    }
}

// Run initialization on document ready
$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('id');

    if (!orderId) {
        console.error('No order ID found in URL');
    } else {
        $('#url-secure-id').val(orderId);
    }

    initializePage();
});



/* $(document).ready(function() {
      // Get the id from query string
      const urlParams = new URLSearchParams(window.location.search);
      const orderId = urlParams.get('id');

      if (!orderId) {
          console.error('No order ID found in URL');
          return;
      }

        // Fetch order details
      $.ajax({
          url: `https://kodiye.io/Order/getOrderDetails?o=${orderId}`,
          method: 'GET',
          success: function(response) {
          //$('#ovloader').ajaxloader("stop");
             // displayOrderDetails(response);

          $('#orderNumber').text(response.displayId);
              orderNumber = response.displayId;
          $('#orderDate').text(response.orderDate);
          $('#orderId').text(orderId);
          },
          error: function(xhr, status, error) {
              showAlert('Failed to fetch order details', 'danger');
          
          }
      });



      // Copy functionality for keys
      $(document).on('click', '.copy-icon', function() {
          const keys = $(this).data('keys');
          navigator.clipboard.writeText(keys).then(() => {
              $(this).addClass('copy-success');
              setTimeout(() => {
                  $(this).removeClass('copy-success');
              }, 1500);
          });
      });

      // Function to create table from response data
      function createTable(data) {
          if (!Array.isArray(data)) {
              console.error('Response data is not an array');
              return 'Invalid response format';
          }

          let tableHtml = `
              <table class="response-table">
                  <thead>
                      <tr>
                          <th>Name</th>
                          <th>Keys</th>
                      </tr>
                  </thead>
                  <tbody>
          `;

          data.forEach(item => {
              const keys = item.codeOrderKeys.map(key => `${key}`);
              const keysList = item.codeOrderKeys.map(key => `<li>${key}</li>`).join('');
              
              tableHtml += `
                  <tr>
                      <td>${item.productName || 'N/A'}</td>
                      <td>
                          <div class="keys-container">
                              <div class="keys-wrapper">
                                  <ul class="keys-list">${keysList}</ul>
                              </div>
                              <i class="fas fa-copy copy-icon" 
                                 title="Copy keys" 
                                 data-keys="${keys.join('\n')}"></i>
                          </div>
                      </td>
                  </tr>
              `;
          });

          tableHtml += `
                  </tbody>
              </table>
          `;

          return tableHtml;
      }

      // Prevent the default checkbox/label behavior
      $('.button_inner').on('click', function(e) {
          e.preventDefault();

         $(this).addClass('loading');
          
          // Make your AJAX call
          $.ajax({
              url: 'https://kodiye.io/Order/unlock',
              method: 'POST',
              data: {
                  id: orderId
              },
              success: function(response) {
                $('.button_inner').removeClass('loading');
                  // On successful AJAX call, trigger the animation
                  $('#unlock_button').prop('checked', true);
                  console.log(response);
                  // Create and display the table
                  const tableHtml = createTable(response.keys);
                  $('.response-table-container').html(tableHtml);
                 setTimeout(() => {
                   $('.unlock_button label').fadeOut();
                      $('.response-container').fadeIn();
                   
                   $("#headertext").css("margin-bottom", "35px");
                  }, 5500);
              },
              error: function(xhr, status, error) {
                  console.error('Error:', error);
                  alert('Failed to unlock order. Please try again.');
                  $('.response-container').hide();
                 $('.button_inner').removeClass('loading');
              }
          });
      });
  });*/